import React from 'react';
import PropTypes from 'prop-types';
import useIsWideScreen from '@medflex/hooks/useIsWideScreen';
import PopupMenu from '../PopupMenu';

const ContextMenuGroup = ({ children }) => {
  const isWideScreen = useIsWideScreen();

  const Group = isWideScreen ? PopupMenu.Group : React.Fragment;

  return <Group>{children}</Group>;
};

ContextMenuGroup.propTypes = {
  children: PropTypes.node,
};

export default ContextMenuGroup;
